import { render, staticRenderFns } from "./KlaviyoSync.vue?vue&type=template&id=7e894228&scoped=true"
import script from "@/views/Settings/KlaviyoSync/KlaviyoSync.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/KlaviyoSync/KlaviyoSync.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/KlaviyoSync/klaviyo-sync.scss?vue&type=style&index=0&id=7e894228&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e894228",
  null
  
)

export default component.exports